import { useField, useFormikContext } from "formik";
import { RenderContainer } from "../RenderContainer";
import React, { useEffect, useMemo, useState } from "react";
import { Renderer2, RendererProps } from "../model";
import Select from "react-select";
import _ from "lodash";
import { SelectOption } from "components/dropdown/Dropdown";

import { ValueType } from "react-select";
import {
  CustomControl,
  CustomOption,
  CustomValue,
  customUseOnClickOutside,
} from "../../SearchListFieldRenderer/SearchListRenderer";

const CustomMultiSelect: React.FC<RendererProps> = ({
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
}) => {
  const { setFieldValue } = useFormikContext();
  const [{ value }] = useField(field.name);

  const [searchString, setSearchString] = useState("");

  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const bind = customUseOnClickOutside(() => {
    setMenuOpen(false);
  }, true);

  const [selectedValues, setSelectedValues] = useState<SelectOption[] | null>(
    null
  );

  const [options, setOptions] = useState<SelectOption[] | null>(null);

  const [selectedValue, setSelectedValue] = useState<SelectOption | null>(null);

  const [readOnlyValues, setReadOnlyValues] = useState<
    string[] | null | string
  >(null);

  const [isInitialized, setIsInitialized] = useState(false);

  const defaultOptions = useMemo(
    () =>
      customField.possibleValues.map(
        (values: { value: string; id: number }) => ({
          label: values.value,
          value: values.id,
        })
      ),
    [customField.possibleValues]
  );

  useEffect(() => {
    if (
      customField.possibleValues &&
      Array.isArray(customField.possibleValues) &&
      customField.possibleValues.length >= 1
    ) {
      setOptions(defaultOptions);
    }
  }, []);

  useEffect(() => {
    if (
      !isInitialized &&
      customField.possibleValuesIds &&
      Array.isArray(customField.possibleValuesIds) &&
      customField.possibleValuesIds.length >= 1 &&
      options
    ) {
      if (isMulti) {
        let initialValues: any = [];
        customField.possibleValuesIds.forEach(value => {
          let match = options.filter(option => option.value === value);
          initialValues.push(match[0]);
        });
        if (initialValues.length >= 1) {
          setSelectedValues(initialValues);
        }
      } else {
        let initialValues: any = [];
        customField.possibleValuesIds.forEach(value => {
          let match = options.filter(option => option.value === value);
          initialValues.push(match[0]);
        });

        if (initialValues.length >= 1) {
          setSelectedValue(initialValues[0]);
        }
      }
      setIsInitialized(true);
    }
    
  }, [options, isInitialized]);

  useEffect(() => {
    if (
      customField.possibleValuesIds &&
      Array.isArray(customField.possibleValuesIds) &&
      customField.possibleValuesIds.length >= 1 &&
      options &&
      readOnly
    ) {
      if (isMulti) {
        let initialValues: any = [];
        customField.possibleValuesIds.forEach(value => {
          let match = options.filter(option => option.value === value);
          initialValues.push(match[0].label);
        });
        if (initialValues.length >= 1) {
          setReadOnlyValues([...initialValues]);
        }
      } else {
        let initialValue: string;
        let match = options.filter(
          option => option.value === customField.possibleValuesIds[0]
        );
        initialValue = match[0].label;
        if (initialValue) {
          setReadOnlyValues(initialValue);
        }
      }
    }
  }, [options]);

  const setDefaultOpts = () => {
    if (
      customField.possibleValues &&
      Array.isArray(customField.possibleValues) &&
      customField.possibleValues.length >= 1
    ) {
      setOptions(defaultOptions);
    }
  };

  const parseTempFieldValue = (
    selectedOption: SelectOption | SelectOption[] | null
  ) => {
    const tempValues = _.cloneDeep(value);
    let fieldValue: number | string[] | null;
    let values: SelectOption[] | SelectOption | null;

    if (selectedOption !== null) {
      if (Array.isArray(selectedOption)) {
        values = selectedOption;
        fieldValue = selectedOption.map(v => v.value);
        if (value === null) {
          values = [];
        }
      } else {
        values = selectedOption;
        fieldValue = [selectedOption.value];
        if (value === null) {
          values = null;
        }
      }
    } else {
      fieldValue = null;
      values = null;
    }
    tempValues[index] = {
      ...tempValues[index],
      possibleValuesIds: fieldValue,
    };
    return [values, tempValues];
  };
  const onFilter = (e: any) => {
    e.preventDefault();
    let inputString = e.target.value;
    if (e.target.value === "") {
      setSearchString("");
      setDefaultOpts();
    } 
    else if (defaultOptions) 
    {
      setSearchString(inputString);
      setOptions(
        defaultOptions.filter((opt: SelectOption) =>
          opt.label.toLowerCase().includes(inputString.toLowerCase())
        ) ?? null
      );
    }
  };

  const Remove = (e: any) => {
    e.stopPropagation();
    isMulti ? setSelectedValues(null) : setSelectedValue(null);
    const [values, tempValues] = parseTempFieldValue(null);
    setFieldValue(field.name, [...tempValues]);
  };

  const onChange = (selectedOption: SelectOption[]) => {
    const [values, tempValues] = parseTempFieldValue(selectedOption);
    if (isMulti) {
      setSelectedValues(values);
    } else {
      setSelectedValue(values);
      setMenuOpen(false);
    }
    setFieldValue(field.name, [...tempValues]);
    setMenuOpen(false);

    // Reset search string and options when an option is selected
    setSearchString("");
    setDefaultOpts();
  };

  const filterOption = (option: any, rawInput: string) => {
    // Return true for all options as we are already filtering when calling the search endpoint. We don't need to filter twice
    return true;
  };

  return (
    <RenderContainer customFieldName={customField.name}>
      {readOnly ? (
        <div
          className={`EditBox ViewOnly EditMultiSelectReadOnly CustomMultiSelect ${
            !isMulti ? "SingleSearchSelect" : ""
          }`}
        >
          {readOnlyValues ? (
            Array.isArray(readOnlyValues) ? (
              readOnlyValues?.map(value => <div className="Item">{value}</div>)
            ) : (
              <div className="Item">{readOnlyValues}</div>
            )
          ) : (
            <div className="Item">-</div>
          )}
        </div>
      ) : options ? (
        <>
          <div className="FormField"></div>
          <div
            className={`EditSingleSelectFieldContainer SearchListRenderer CustomMultiSelect ${
              !isMulti ? "SingleSearchSelect" : ""
            }`}
            {...bind}
          >
            <Select
              className={`CustomSelect EditSingleSelect SearchListRenderer${
                isMulti ? " Single" : ""
              } ${classWrapper ? classWrapper : ""}`}
              classNamePrefix={`CustomSelect`}
              options={options ?? []}
              value={isMulti ? selectedValues : selectedValue}
              onChange={
                onChange as (
                  selectedOption: ValueType<SelectOption, any>
                ) => void
              }
              selectProps={{
                menuOpen: menuOpen,
                setMenuOpen: setMenuOpen,
                remove: Remove,
              }}
              isMulti={isMulti ?? false}
              filterOption={filterOption}
              isSearchable={false}
              menuIsOpen={menuOpen}
              onMenuOpen={() => {
                setMenuOpen(true); // NOTE: This is needed to make click on mobile phones work
              }}
              onMenuClose={() => {
                // setMenuOpen(false); // NOTE: This is needed to make click on mobile phones work
              }}
              noOptionsMessage={() => "No options"}
              placeholder={false}
              closeMenuOnSelect={false}
              components={{
                Option: CustomOption,
                Control: CustomControl,
                SingleValue: CustomValue,
              }}
              styles={{
                multiValue: styles => {
                  return {
                    ...styles,
                    backgroundColor: "#DEEBFF",
                    color: "#4C9AFF",
                  };
                },
                multiValueLabel: styles => ({
                  ...styles,
                  color: "#4C9AFF",
                  fontSize: "1.1rem",
                }),
                multiValueRemove: styles => ({
                  ...styles,
                  color: "#4C9AFF",
                  ":hover": {
                    backgroundColor: "red",
                    color: "white",
                  },
                }),
              }}
              backspaceRemovesValue={false} // Prevent backspace key presses deleting selected items
            />
            <div className={`${menuOpen ? "behind" : "hide"}`}>
              <input
                className="custom-input-search"
                value={searchString}
                onChange={onFilter}
                placeholder="Type search here"
              />
            </div>
          </div>
        </>
      ) : (
        <div className="EditBox ViewOnly NoOptions"> Error: No data </div>
      )}
    </RenderContainer>
  );
};

export const customMultiSelect: Renderer2 = (
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
  booleanField
) => (
  <CustomMultiSelect
    customField={customField}
    index={index}
    readOnly={readOnly}
    handleOnChange={handleOnChange}
    field={field}
    isMulti={isMulti}
    classWrapper={classWrapper}
    booleanField={booleanField}
  />
);
